<template>
  <ui-row>
    <ui-col col="12">
      <h3 class="page-title">Event list<router-link class="right" to="/vip/event/create" v-if="isAdmin || isVip">Create new</router-link></h3>

    </ui-col>
    <ui-col col="12" v-if="eventList.length" class="event-list">
      <card-event :event="event" :shadowHover="false" v-for="event of eventList" :key="event.id"></card-event>
    </ui-col>
  </ui-row>
</template>
<script>
import api from "../../api/index";
import vipApi from '../../api/vip.js'
import CardEvent from '../../components/event/event-card.vue'
import { mapGetters } from "vuex";
import userRole from '../../mixin/role.js'
export default {
  data() {
    return {
      eventList: []
    };
  },
  components: {
    CardEvent
  },
  mixins: [userRole],
  computed: {
    ...mapGetters(["authInfo"])
  },
  mounted() {
    api
      .getEventList({ type: "all" })
      .then(res => {
        this.eventList = res.data.eventList;
      })
      .catch(err => {});
  },
  methods: {}
};

</script>
